import { BigNumber } from '@ethersproject/bignumber';

/**
 * Compute 10^n as a {@see BigNumber}
 */
export default function e(n: number): BigNumber {
  return BigNumber.from(BigNumber.from(10).pow(n));
}
